export const countryNames = {
    EE: 'Estonia',
    DE: 'Germany',
    FR: 'France',
    ES: 'Spain',
    IT: 'Italy',
    NL: 'Netherlands',
    GB: 'United Kingdom',
    BE: 'Belgium',
    CH: 'Switzerland',
    AT: 'Austria',
    SE: 'Sweden',
    NO: 'Norway',
    DK: 'Denmark',
    FI: 'Finland',
    PT: 'Portugal',
    PL: 'Poland',
    CZ: 'Czech Republic',
    SK: 'Slovakia',
    HU: 'Hungary',
    RO: 'Romania',
    BG: 'Bulgaria',
    LV: 'Latvia',
    LT: 'Lithuania'
    // Add more countries as needed
};
